import {
  addressApartmentBooking,
  addressCity,
  addressState,
  addressStreet,
  addressZip,
  billingPhone,
  cardNumber,
  createValidator,
  expirationDate,
  genericEmail,
  nameOnCard,
} from './validation';

const paymentPenaltyChargeFields = {
  addressApartment: [addressApartmentBooking],
  addressCity: [addressCity],
  addressStateIntl: [addressState],
  addressStreet: [addressStreet],
  addressZip: [addressZip],
  billingEmail: [genericEmail],
  billingPhone: [billingPhone],
  cardNumber: [cardNumber],
  expirationDate: [expirationDate],
  nameOnCard: [nameOnCard],
};

const paymentPenaltyChargeValidator = createValidator(paymentPenaltyChargeFields);

export const paymentPenaltyChargeValidation = values => {
  return paymentPenaltyChargeValidator(values);
};

export default paymentPenaltyChargeValidation;
